import type { Hex } from "viem";

/** ERC-8021 attribution marker: sixteen bytes of 0x8021 that identify a data suffix. */
const ERC_8021_MARKER = "80218021802180218021802180218021";

/**
 * The ERC-8021 "schema 0" data suffix for a Base Builder Code, appended to a transaction's calldata
 * so Base attributes the onchain activity to this app: `codes ‖ codesLength(1 byte) ‖ schemaId(0x00)
 * ‖ marker`. The suffix is inert to the contracts being called — it trails the calldata and is
 * ignored by the ABI decoder.
 */
export function builderCodeDataSuffix(code: string): Hex {
  if (!/^[\x21-\x7e]{1,255}$/.test(code)) {
    throw new Error("Builder code must be 1-255 printable ASCII characters");
  }
  const codesHex = Array.from(code, (c) => c.charCodeAt(0).toString(16).padStart(2, "0")).join("");
  const length = code.length.toString(16).padStart(2, "0");
  return `0x${codesHex}${length}00${ERC_8021_MARKER}`;
}
